import type { FunctionComponent } from 'react';
import type { TypeDataListItemProps } from './types';

/**
 * DataListItem es el elemento del que se compone
 * DataList.
 */
export const DataListItem: FunctionComponent<TypeDataListItemProps> = ({
  title,
  children,
  as: HtmlTag = 'span',
  className,
}: TypeDataListItemProps) => (
  <div className="flex flex-col border-b border-primary-200 pb-6">
    {title && (
      <HtmlTag
        className={`u-subtitle u-subtitle--s pb-4 ${!!className ? className : ''}`}
      >
        {title}
      </HtmlTag>
    )}
    <div className="u-body u-body--s text-typo-tertiary">{children}</div>
  </div>
);
